import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HC_more from "highcharts/highcharts-more";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import wordcloud from "highcharts/modules/wordcloud.js";
import HighchartsNetworkgraph from "highcharts/modules/networkgraph";
import HighchartsMore from "highcharts/highcharts-more";
import { NETWORKGRAPH, MOREGRAPH } from "utils/constants";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import FullScreen from "highcharts/modules/full-screen";

const typeChart = {
    [NETWORKGRAPH]: HighchartsNetworkgraph,
    [MOREGRAPH]: HighchartsMore,
};

const Chart = ({ options, type = null, onChartReady }) => {
    HC_more(Highcharts);
    NoDataToDisplay(Highcharts);
    wordcloud(Highcharts);
    Exporting(Highcharts);
    FullScreen(Highcharts);

    type && typeChart[type](Highcharts);

    return (
        <div id="chart-component">
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                callback={(chart) => {
                    if (onChartReady) onChartReady(chart);
                }}
            />
        </div>
    );
};

export default Chart;
